module.exports = __webpack_public_path__ + "static/about-portrait-e385360b70ee48cd09d230245afb1570.jpg";